import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getBatchesGeneral, getBatchesMain, getSubSales, manageSale } from '../../actions/inventoryActions'
import InventoryDetaillView from '../../containers/Inventory/InventoryDetaill/InventoryDetaill'

const InventorySaleDetaill = ({ match ,history}) => {
    const dispatch = useDispatch()
    const { subSales } = useSelector(state => state.inventory)
    const { userInfo } = useSelector(state => state.userInfo)
    useEffect(() => {

        dispatch(getSubSales(match.params.id))
        return () => {

        }
    }, [match.params.id])

    const getBatches = (productId) => {
        let id = "";
        let type = ""
        if (userInfo.representativeID) {
            if (userInfo.representativeID.state ===2) {
                type = "general"
                id = userInfo.representativeID._id
            }
        }
        if (userInfo.franchiseID) {
            if (userInfo.franchiseID.state ===2) {
                type = "general"
                id = userInfo.franchiseID._id
            }
        }
        if (userInfo.warehouseID) {
            type = "main"
            id = userInfo.warehouseID

        }

        if (type ==='general') {
            dispatch(getBatchesGeneral(id, productId))
        }

        if (type ==='main') {
            dispatch(getBatchesMain(id, productId))
        }



    }
    const manageSaleFn = (specifications) =>{
        dispatch(manageSale(match.params.id,1,specifications,history))

    }
    return (
        <InventoryDetaillView  sale ={subSales[0]?.saleId} subSales={subSales} getBatches={getBatches} manageSaleFn ={manageSaleFn} />
    )
}

export default InventorySaleDetaill